import notificationActionConstants from '../constants/notificationActionConstants';

const initialState = {
  notificationsEnabled: {},
  notificationsList: [],
  optOutNotifications: [],
  unreadNotifications: 0,
  notificationLoader: false,
  notificationsListLoading: false,
  readAllLoading: false,
  isLastPage: false,
  readLoading: false,
};

const notificationReducer = (state = initialState, action = {}) => {
  let notificationsList = [];
  switch (action.type) {
    case notificationActionConstants.GET_NOTIFICATION_SETTINGS:
      return {
        ...state,
        notificationsEnabled: action.payload,
      };
    case notificationActionConstants.GET_OPT_OUT_SETTINGS:
      return {
        ...state,
        optOutNotifications: action.payload,
      };

    case notificationActionConstants.UPDATE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        notificationsEnabled: action.payload,
      };
    case notificationActionConstants.GET_NOTIFICATIONS_LIST:
      return {
        ...state,
        notificationLoader: true,
        notificationsListLoading: !action.payload.isPagination,
        notificationsList: action.payload.isPagination ? state.notificationsList : [],
      };
    case notificationActionConstants.GET_NOTIFICATIONS_LIST_SUCCESS:
      notificationsList = action.payload.isPagination
        ? state.notificationsList.concat(action.payload.notifications)
        : action.payload.notifications;
      return {
        ...state,
        notificationsList,
        isLastPage: action.payload.notifications.length === 50,
        notificationLoader: false,
        notificationsListLoading: false,
        unreadNotifications: action.payload.unreadNotifications,
      };

    case notificationActionConstants.GET_NOTIFICATIONS_LIST_ERROR:
      return {
        ...state,
        notificationsListLoading: false,
        notificationLoader: false,
      };

    case notificationActionConstants.SET_READ_ALL:
      return {
        ...state,
        readAllLoading: true,
      };
    case notificationActionConstants.SET_READ_ALL_SUCCESS:
      return {
        ...state,
        readAllLoading: false,
        unreadNotifications: action.payload.unreadNotifications,
      };
    case notificationActionConstants.SET_READ_ALL_ERROR:
      return {
        ...state,
        readAllLoading: false,
      };
    case notificationActionConstants.SET_READ:
      return {
        ...state,
        readLoading: true,
      };
    case notificationActionConstants.SET_READ_SUCCESS:
      notificationsList = state.notificationsList.map((notification) =>
        notification.id === action.payload.notification.id ? action.payload.notification : notification
      );
      return {
        ...state,
        readLoading: false,
        notificationsList,
        unreadNotifications: action.payload.unreadNotifications,
      };
    case notificationActionConstants.SET_READ_ERROR:
      return {
        ...state,
        readLoading: false,
      };

    default:
      return state;
  }
};

export default notificationReducer;
